import { render, staticRenderFns } from "./copytask.vue?vue&type=template&id=3d284097&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "copytask.vue"
export default component.exports